import { LOCAL_STORAGE } from 'app/commons/constants'
import { FTL_WEB_APP } from 'app/commons/constants/env.const'
import { showLoading } from 'app/commons/helpers/loadingUtils'
import { setCookie } from 'app/commons/helpers/storage'
import * as Utils from 'app/commons/helpers/utils'
import authApi from 'app/services/authApi'
import settingApi from 'app/services/settingApi'
import * as configAction from 'app/store/config/configAction'
import { modalCreateActions } from 'app/store/modal/modalSlice'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'

import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import _get from 'lodash.get'

import moment from 'moment'

import { countries } from '../../commons/constants/countriesLanguage.const'
import { DEFAULT_AVATAR, ICON_FLAG_EN, LOGO_TRANSPORTIFY_WHITE, LOGO_WHITE } from '../../commons/constants/image.const'
import { MODAL_TYPES } from '../../commons/constants/modal.const'
// import DevinaMenu from './DevinaMenu/index'
import Menu from './Menu/index'
import './style.scss'

const defaultSelectCountry = {
  default: {
    name: 'Select Country',
    languages: {
      en: 'en',
    },
    iconFlag: ICON_FLAG_EN,
  },
}

const languages = ['vi-VN', 'th-TH', 'id-ID', 'en-US']

class Header extends Component {
  constructor() {
    super()
    this.state = {
      openLoadDB: false,
      openShipments: false,
      openNotification: false,
      openCountry: false,
      activeLanguage: 'en',
      activeCountry: 'default',
      toggleSelected: true,
      countriesList: defaultSelectCountry,
    }
  }

  componentDidMount() {
    const { location, history } = this.props
    const urlParams = new URLSearchParams(location.search)
    const countryCode = urlParams.get('countrycode')
    const language = urlParams.get('language')

    const defaultCountry = localStorage.getItem(LOCAL_STORAGE.DEFAULT_COUNTRY)
    const defaultLanguage = localStorage.getItem(LOCAL_STORAGE.DEFAULT_LANGUAGE)

    if (defaultLanguage && defaultCountry && !language) {
      this.setStateWithCountryCodeAndLanguage(defaultCountry, defaultLanguage)
    } else {
      this.getCountry(countryCode || 'id', language || 'en')
    }
    // remove param language and country
    language && urlParams.delete('language')
    history.push({ search: urlParams.toString() })
  }

  onClickSignUp() {
    const { actions } = this.props
    actions.openModal({ typeModal: MODAL_TYPES.SIGNUP })
  }

  onClickLogin() {
    const { actions } = this.props
    actions.openModal({ typeModal: MODAL_TYPES.LOGIN })
  }

  setStateWithCountryCodeAndLanguage(countryCode, language) {
    this.setState(
      {
        activeCountry: countryCode,
        countriesList: countries,
      },
      () => {
        this.changeLanguage(_get(countries[countryCode], `languages[${language}]`, 'en'))
      }
    )
  }

  handleCountryAndLanguage(countryCode, language = 'en') {
    const { activeLanguage } = this.state
    this.setStateWithCountryCodeAndLanguage(countryCode, language)
    localStorage.setItem(LOCAL_STORAGE.DEFAULT_COUNTRY, countryCode)
    localStorage.setItem(LOCAL_STORAGE.DEFAULT_LANGUAGE, language || activeLanguage)
  }

  getCountry(newCountryCode, newLanguage) {
    this.handleCountryAndLanguage(newCountryCode, newLanguage)
  }

  getFlagIcon(countryCode) {
    const { countriesList } = this.state
    if (countriesList[countryCode]) {
      return countriesList[countryCode].iconFlag
    }
    return ICON_FLAG_EN
  }

  changeLanguage = async (lang) => {
    let language = languages.filter((item) => item.slice(0, 2) === lang)
    if (language.length === 0) {
      if (lang === 'vn') {
        language = [languages[0]]
      }
    }
    if (lang === 'vn') {
      lang = 'vi'
    }
    await this.setState({
      activeLanguage: lang,
    })
    localStorage.setItem(LOCAL_STORAGE.DEFAULT_LANGUAGE, lang)
    const { i18n } = this.props
    setCookie('language', lang, 1)
    i18n.changeLanguage(lang)
    moment.locale(lang)
  }

  setActiveCountry = async (actLan) => {
    window.redirectToCountry = actLan
    const result = await settingApi.getServiceAreaByCountry(actLan, 'en')
    if (result && result.status === 200) {
      Utils.gotoStep1({ area_id: result.id })
    }
  }

  onNewShipment = () => {
    showLoading()
    window.location.replace(FTL_WEB_APP || '')
  }

  renderCountryName = (countryCode) => {
    let res = ''
    switch (countryCode) {
      case 'id':
        res = 'Indonesia'
        break
      case 'th':
        res = 'Thailand'
        break
      case 'ph':
        res = 'Philippines'
        break
      default:
        res = 'Vietnam'
        break
    }
    return res
  }

  managementShipment = () => {
    const { history } = this.props
    history.push('/manager-shipments')
  }

  changeToggle(toggleName) {
    const { toggleSelected } = this.state
    this.setState({
      toggleSelected: !toggleSelected,
    })
    alert(`You change toggle ${toggleName}`)
  }

  renderListCountries() {
    const result = []
    const { countriesList } = this.state
    Object.keys(countriesList).forEach((key) => {
      result.push(
        <div role="presentation" key={key} className="Dropdown-Menu-Item" onClick={() => this.setActiveCountry(key)}>
          {countriesList[key].name}
        </div>
      )
    })
    return result
  }

  renderCountries = () => {
    const { openCountry, activeCountry, countriesList } = this.state
    return (
      <div className="Menu-Nav-Item mr6">
        <div className={`dark-green Dropdown ${openCountry && 'open'}`}>
          <div
            role="presentation"
            className="Dropdown-Close"
            onClick={() =>
              this.setState((prevState) => ({
                openCountry: !prevState.openCountry,
              }))
            }
          />
          <div
            role="presentation"
            className="Dropdown-Head"
            onClick={() =>
              this.setState((prevState) => ({
                openCountry: !prevState.openCountry,
              }))
            }
          >
            <div className="Dropdown-Head-Item">{_get(countriesList, `[${activeCountry}].name`, '')}</div>
            <div className="Dropdown-Head-Caret">
              <i className="material-icons fs24">arrow_drop_down</i>
            </div>
            <div className="Dropdown-Head-Arrow left overflow-auto" />
          </div>
          <div className="right Dropdown-Menu">{this.renderListCountries()}</div>
        </div>
      </div>
    )
  }

  switchLanguage = async (language) => {
    const { isLogged } = this.props
    if (isLogged) {
      await authApi.updateCustomerMe(
        {
          language: language,
        },
        null
      )
    }
    window.redirectToLanguage = language
    window.location.reload()
  }

  render() {
    const { activeCountry, countriesList, activeLanguage } = this.state
    const {
      isLogged,
      t,
      actions,
      login: { accounts = {} },
      configFTL,
      customerFtlConfig,
    } = this.props
    const countryCode = localStorage.getItem(LOCAL_STORAGE.DEFAULT_COUNTRY)
    const companyId = Utils.getCompanyId(accounts)
    const currentEmploy = companyId ? Utils.getCompanyAccount(companyId, accounts) : {}
    const isLoginAndVerifySms = !!(accounts.id && accounts.sms_confirmed_at)
    let hideAreaSelector = _get(customerFtlConfig, 'hide_area_selector')
    if (!hideAreaSelector) {
      hideAreaSelector = _get(configFTL, 'settings.hide_area_selector_for_non_login')
    }

    return (
      <div className="header-bar">
        {Utils.configHeadHelmet()}
        <div className="Menu fixed fixed-width">
          <div className="Logo cur-pointer">
            {!!companyId && (
              <div className="header__logo-badge">
                For <br /> Business
              </div>
            )}
            <img
              className={!!companyId ? 'ml35' : ''}
              src={countryCode === 'ph' ? LOGO_TRANSPORTIFY_WHITE : LOGO_WHITE}
              alt="Logo deliveree white"
              onClick={this.onNewShipment}
              role="presentation"
            />
          </div>
          <div className="Menu-Nav left">
            <Menu
              currentEmploy={currentEmploy}
              currentCustomer={accounts}
              isLoginAndVerifySms={isLoginAndVerifySms}
              isBusiness={!!companyId}
            />
          </div>
          <div className="Menu-Nav right">
            {!hideAreaSelector && this.renderCountries()}
            <div className="Menu-Nav-Item Menu-Nav-Item-Flag mr5">
              <div
                role="presentation"
                className={activeLanguage !== 'en' || activeCountry === 'ph' ? 'active' : ''}
                rel="nofollow"
                data-method="put"
                onClick={() => {
                  this.switchLanguage(countriesList[activeCountry].languages[activeCountry])
                }}
              >
                <img src={this.getFlagIcon(activeCountry)} alt={activeCountry} />
              </div>
              {activeCountry !== 'ph' && activeCountry !== 'default' && (
                <div
                  className={activeLanguage === 'en' ? 'active' : ''}
                  rel="nofollow"
                  role="presentation"
                  data-method="put"
                  onClick={() => {
                    this.switchLanguage(countriesList[activeCountry].languages.en)
                  }}
                >
                  <img src={ICON_FLAG_EN} alt="En" />
                </div>
              )}
            </div>
            {isLogged && accounts && (
              <div
                className="Menu-Nav-Item"
                onClick={() => {
                  actions.openModal({ typeModal: MODAL_TYPES.USER_PROFILE })
                }}
                role="presentation"
              >
                <div className="rounded Avatar__header" id="menu-avatar">
                  <img
                    alt=""
                    onError={(e) => {
                      e.target.src = DEFAULT_AVATAR
                    }}
                    src={(companyId ? currentEmploy?.photo_url : accounts?.avatar_square) || DEFAULT_AVATAR}
                  />
                </div>
              </div>
            )}
            {!isLogged && (
              <div className="Menu-Nav-Item Menu-Nav-Item-Button">
                <button
                  type="button"
                  className="white-text white-border Button"
                  onClick={() => {
                    this.onClickLogin()
                  }}
                >
                  {t('common.header.signIn')}
                </button>
              </div>
            )}
            {!isLogged && (
              <div className="Menu-Nav-Item Menu-Nav-Item-Button">
                <button
                  type="button"
                  className="white-text white-border Button"
                  onClick={() => {
                    this.onClickSignUp()
                  }}
                >
                  {t('common.header.signup')}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => ({
  isLogged: state.auth.isLogged,
  login: _get(state, 'auth.login', {}),
  data: _get(state, 'configuration.data'),
  notification: state.notification,
  access_token: _get(state, 'auth.login.access_token', ''),
  customerFtlConfig: _get(state, 'auth.customerFtlConfig', {}),
  configFTL: _get(state, 'configuration.configFTL', {}),
})

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...configAction,
      ...modalCreateActions,
    },
    dispatch
  ),
})

Header.propTypes = {
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
}

export default withRouter(withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Header)))
